import React from "react";
import { createBrowserRouter, Navigate } from 'react-router-dom'
// import Home from '@/pages/home'
const Home = React.lazy(() => import("@/pages/home"));
// import About from '@/pages/about'
const About = React.lazy(() => import("@/pages/about"));
// import Profile from '@/pages/about/profile'
const Profile = React.lazy(() => import("@/pages/about/profile"));
// import History from '@/pages/about/history'
const History = React.lazy(() => import("@/pages/about/history"));
// import Honors from '@/pages/about/honors'
const Honors = React.lazy(() => import("@/pages/about/honors"));
// import Operation from '@/pages/about/operation'
const Operation = React.lazy(() => import("@/pages/about/operation"));
// import Products from '@/pages/about/products'
const Products = React.lazy(() => import("@/pages/about/products"));
// import Responsibility from '@/pages/responsibility'
const Responsibility = React.lazy(() => import("@/pages/responsibility"));
// import Inventors from '@/pages/inventors'
const Inventors = React.lazy(() => import("@/pages/inventors"));
// import News from '@/pages/news/index'
const News = React.lazy(() => import("@/pages/news/index"));
// import NewsDetail from '@/pages/news/detail'
const NewsDetail = React.lazy(() => import("@/pages/news/detail"));
// import Careers from '@/pages/careers'
const Careers = React.lazy(() => import("@/pages/careers"));
// import Apply from '@/pages/careers/apply'
const Apply = React.lazy(() => import("@/pages/careers/apply"));
// import Find from '@/pages/find'
const Find = React.lazy(() => import("@/pages/find"));
// import Entry from '@/pages/entry'
const Entry = React.lazy(() => import("@/pages/entry"));
// import Title from '@/components/Title'
const Title = React.lazy(() => import("@/components/Title"));
 
// 全局路由
export const globalRouters = createBrowserRouter([
    // 如果URL没有"#路由"，跳转Home页面
    {
        path: '/',
        element: (
            <Entry />
        ),
        children : [
            // 精确匹配"/home"，跳转Home页面
            {
                path: '/',
                element: <Title element={Home} meta={{ title: "Century Commodities Solution Official Website–CCS Supply Chain Management Co.,Ltd." }} />,
            },
            {
                path: '/home',
                element: <Title element={Home} meta={{ title: "Century Commodities Solution Official Website–CCS Supply Chain Management Co.,Ltd." }} />,
            },
            {
                path: '/about',
                element: <Title element={About} meta={{ title: "ABOUT US" }} />,
            },
            {
                path: '/about/profile',
                element: <Title element={Profile} meta={{ title: "OUR PROFILE" }} />,
            },
            {
                path: '/about/honors',
                element: <Title element={Honors} meta={{ title: "OUR HONORS" }} />,
            },
            {
                path: '/about/history',
                element: <Title element={History} meta={{ title: "OUR HISTORY" }} />,
            },
            {
                path: '/about/operation',
                element: <Title element={Operation} meta={{ title: "INTERNATIONAL OPERATION" }} />,
            },
            {
                path: '/about/products',
                element: <Title element={Products} meta={{ title: "COMMODITY PRODUCTS" }} />,
            },
            {
                path: '/responsibility',
                element: <Title element={Responsibility} meta={{ title: "RESPONSIBILITY" }} />,
            },
            {
                path: '/inventors',
                element: <Title element={Inventors} meta={{ title: "INVESTORS" }} />,
                
            },
            {
                path: '/careers',
                element: <Title element={Careers} meta={{ title: "CAREERS" }} />,
            },
            {
                path: '/careers/apply',
                element: <Title element={Apply} meta={{ title: "CAREERS" }} />,
            },
            {
                path: '/news',
                element: <Title element={News} meta={{ title: "NEWS" }} />,
            },
            {
                path: '/news/detail',
                element: <Title element={NewsDetail} meta={{ title: "NEWS" }} />,
            },
            {
                path: '/find',
                element: <Title element={Find} meta={{ title: "FIND US" }} />,
            },
        ]
    },
    // 未匹配,跳转Home页面
    {
        path: '*',
        element: <Navigate to="/home" />,
    },
])